import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import {
  InboxOutlined,
  HomeOutlined,
  MessageOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Layout as Layer, Row } from "antd";
import Navbar from "./navbar";

const LeadsLayout = ({ children }) => {
  const { push } = useHistory();
  return (
    <Layer style={{ minHeight: "100vh", maxHeight: "100vh" }}>
      <Layer
        style={{
          display: "flex",
          displayDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Navbar />
          {children}
        </div>
        <div
          style={{
            borderRadius: 40,
            alignSelf: "center",
            position: "absolute",
            marginTop: "85vh",
            background:
              "radial-gradient(ellipse at top, #142b22, #000000),radial-gradient(ellipse at bottom, #000000, transparent)",
            marginBottom: 60,
            height: 80,
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
            width: "90%",
          }}
        >
          <Row style={{ padding: 10, justifyContent: "space-around" }}>
            <div
              style={{
                borderRadius: 50,
                height: 60,
                width: 60,
                transition: "background 1s",
                background:
                  window.location.pathname === "/home" ? "#04C78E" : "#142b22",
              }}
              onClick={() => push("/home")}
            >
              <Row style={{ justifyContent: "center", marginTop: 10 }}>
                <HomeOutlined style={{ fontSize: 40, color: "white" }} />
              </Row>
            </div>
            <div
              style={{
                borderRadius: 50,
                height: 60,
                width: 60,
                transition: "background 1s",
                background:
                  window.location.pathname === "/offers"
                    ? "#04C78E"
                    : "#142b22",
              }}
              onClick={() => push("/offers")}
            >
              <Row style={{ justifyContent: "center", marginTop: 10 }}>
                <InboxOutlined style={{ fontSize: 40, color: "white" }} />
              </Row>
            </div>
            <div
              style={{
                borderRadius: 50,
                height: 60,
                width: 60,
                transition: "background 1s",
                background:
                  window.location.pathname === "/chat" ? "#04C78E" : "#142b22",
              }}
              onClick={() => push("/chat")}
            >
              <Row style={{ justifyContent: "center", marginTop: 10 }}>
                <MessageOutlined style={{ fontSize: 40, color: "white" }} />
              </Row>
            </div>

            <div
              style={{
                borderRadius: 50,
                height: 60,
                width: 60,
                transition: "background 1s",
                background:
                  window.location.pathname === "/settings"
                    ? "#04C78E"
                    : "#142b22",
              }}
              onClick={() => push("/settings")}
            >
              <Row style={{ justifyContent: "center", marginTop: 10 }}>
                <SettingOutlined style={{ fontSize: 40, color: "white" }} />
              </Row>
            </div>
          </Row>
        </div>
      </Layer>
    </Layer>
  );
};

LeadsLayout.propTypes = {
  children: PropTypes.any.isRequired,
};

export default LeadsLayout;
